import { Field } from '@catering/ui';
import type { JSX } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';

export type AddressFieldKey = 'street' | 'number' | 'city' | 'province' | 'postalCode';

const LABELS: Record<AddressFieldKey, string> = {
  street: 'Calle',
  number: 'Número',
  city: 'Ciudad',
  province: 'Provincia',
  postalCode: 'Código postal',
};

const KEYS: AddressFieldKey[] = ['street', 'number', 'city', 'province', 'postalCode'];

export interface AddressFieldsProps {
  legend: string;
  register: (field: AddressFieldKey) => UseFormRegisterReturn;
  errors?: Partial<Record<AddressFieldKey, string | undefined>>;
}

/**
 * Shared between `CustomerForm`'s billing address (PR 6) and `SiteForm`'s
 * address (PR 7a): both mirror `addressSchema` from `apps/api`. `register`
 * is a thin adapter so each caller can point at its own field path
 * (`billingAddress.street` vs `address.street`) without this component
 * knowing the parent field name.
 */
export function AddressFields({ legend, register, errors }: AddressFieldsProps): JSX.Element {
  return (
    <fieldset className="flex flex-col gap-3">
      <legend className="text-sm font-medium text-slate-900">{legend}</legend>
      {KEYS.map((key) => (
        <Field key={key} label={LABELS[key]} {...register(key)} {...maybeError(errors?.[key])} />
      ))}
    </fieldset>
  );
}

function maybeError(message: string | undefined): { error: string } | Record<string, never> {
  return message === undefined ? {} : { error: message };
}
